import React, { useState, useEffect, useRef } from "react";
import { FaBars } from "react-icons/fa";
import { IconContext } from "react-icons/lib";
import { FaMobile } from "react-icons/fa";
import { IoCaretDownOutline } from "react-icons/io5";
import { FaUserAlt } from "react-icons/fa";
import Cookies from "js-cookie";
import { AiFillSetting } from "react-icons/ai";
import { TiInfoOutline } from "react-icons/ti";
import {
  Nav,
  NavbarContainer,
  NavLogo,
  MobileIcon,
  NavMenu,
  NavItem,
  SvgLogo,
} from "./NavbarElements";
import navbarLogo from "../../assets/images/jobDashlogo.png";
import "react-phone-input-2/lib/style.css";
import Overlay from "../Overlay";
import SidebarOverlay from "../SidebarOverlay";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import axios from "../../axios";
import { toast } from "react-toastify";
import dummyProfile from "../../assets/images/lady.png";
import { MdAccountCircle } from "react-icons/md";
import { FiLogOut } from "react-icons/fi";
import { MdLock } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";
import { PiPassword } from "react-icons/pi";
import { AiOutlineUser } from "react-icons/ai";
import { Modal } from "../../components/Modal";
import "./Nav.css";
import { Link, useNavigate } from 'react-router-dom';
import { TextField, Popover, Box } from "@mui/material";
import { FaRegBell } from "react-icons/fa6";
import Placeholder from "../../assets/images/placeholder.jpg";
import { extractDate } from "../../utils/functions";

const Navbar = (props) => {

  const { userData, history, sidebar, setSidebar, setUsers } = props;
  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);


  const accessToken = sessionStorage.getItem("token") || localStorage.getItem("token");
  const adminData = JSON.parse(sessionStorage.getItem("userData") || localStorage.getItem("userData"));

  const isSubAdmin = adminData?.userType === "subAdmin";

  // Map frontend route slugs
  const moduleRoutes = {
    "Dashboard": "dashboard",
    "User Management": "userManagement",
    "Skill Management": "skillsManagement",
    "Blacklist Word Management": "blockManagement",
    "Commission Management": "commissionSettings",
    "Gigs Management": "gigsManagement",
    "Reported Gig Management": "reportedGigManagement",
    "Payment Management": "paymentManagement",
    "CMS Management": "cmsCondition",
    "Notification Management": "notificationManagement",
    "Leader board": "leaderboardManagement",
    "Ticket Management": "ticketManagement",
    "Feedback Management": "feedbackManagement"
  };

  // Default route
  let firstAllowedRoute = "/dashboard";

  // Logic for subAdmin permissions
  if (isSubAdmin && Array.isArray(adminData?.adminpermissions?.modules)) {
    const modules = adminData.adminpermissions.modules;

    for (const module of modules) {
      const hasAnyPermission = Object.values(module.permissions).some(value => value === true);

      if (hasAnyPermission && moduleRoutes[module.moduleName]) {
        firstAllowedRoute = `/${moduleRoutes[module.moduleName]}`;
        break;
      }
    }
  }



  var showProfileSidebar = Cookies.get("showProfileSidebar") ? JSON.parse(Cookies.get("showProfileSidebar")) : "";

  const [defaultState, setDefaultState] = useState({
    isLogin: "",
    isSignup: "",
    isForget: "",
    isOtp: "",
    isReset: "",
    isProfileUpdate: "",
    isApproved: "",
    isRejected: "",
    isProfileComplete: "",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingSidebarBackground, setIsLoadingSidebarBackground] =
    useState(false);
  const [DisplayMenu, setDisplayMenu] = useState(false);
  const showSidebar = () => setSidebar(!sidebar);
  const showBackOverlay = () =>
    setIsLoadingSidebarBackground(!isLoadingSidebarBackground);

  const leftBoxRef = useRef(null);

  // Open Popover
  const [anchorEl, setAnchorEl] = useState(null);

  const handleFilterClick = (event) => {
    setAnchorEl(event.currentTarget); // Open the filter popover
  };

  const open = Boolean(anchorEl);
  const id = open ? "filter-popover" : undefined;

  const handleClose = () => {
    setAnchorEl(null); // Only close the popover without resetting
  };



  useEffect(() => {
    const handleClickOutside = (event) => {
      if (leftBoxRef.current && !leftBoxRef.current.contains(event.target)) {
        setDisplayMenu(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    setIsLoading(true);
    setOpenModal(false);

    try {
      const { data } = await axios.get(`/private/logout`, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      localStorage.removeItem("email");
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
      sessionStorage.removeItem("email");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("userData");
      Cookies.remove("showProfileSidebar");
      setUsers("");

      // toast.success(data.message, {
      //   position: "top-right",
      // });

      navigate("/");
    } catch (error) {
              
      toast.error("Something went wrong", {
        position: "top-right",
      });
    } finally {
      setIsLoading(false);
    }
  };

  const showDisplaymenu = () => {
    setDisplayMenu(!DisplayMenu);
  };

  const handleProfile = () => {
    Cookies.set("showProfileSidebar", true, { expires: 365 });
    showDisplaymenu();
    navigate("/profile");
  };

  const changedPassword = () => {
    Cookies.set("showProfileSidebar", true, { expires: 365 });
    showDisplaymenu();
    navigate("/changedPassword");
  };

  const leftBox = (
    <>
      <NavMenu ref={leftBoxRef}>
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
            }}
            onClick={() => showDisplaymenu()}
          >
            <div className="nav-btn-logo">
              <SvgLogo
                className="profile-image"
                src={userData?.profileImage ? userData?.profileImage : dummyProfile}
              />
            </div>
            <div>
              <IoCaretDownOutline />
            </div>
          </div>
          {DisplayMenu ? (
            <div className="nav-profile-container">
              <div className="d-flex align-items-center justify-content-end">
                <RxCross2
                  style={{
                    cursor: "pointer",
                    position: "relative",
                    top: "6px",
                    right: "10px"
                  }}
                  onClick={() => showDisplaymenu()}
                />
              </div>
              <div className="nav-profile-section p-3">
                <div className="profile-dropdown-section">
                  <div className="nav-btn-logo">
                    <SvgLogo
                      className="profile-image"
                      src={userData?.profileImage ? userData?.profileImage : dummyProfile}
                    />
                  </div>
                  <div className="ms-2 text-start">
                    <div className="profile-name fw-600" style={{ color: "rgba(24, 24, 24, 1)" }}>
                      {`${userData.firstName} ${userData.lastName}`}
                    </div>
                    <div className="admin-settings">{`${userData.userType}`}</div>
                  </div>
                </div>

                <div className="d-flex align-items-center" style={{ margin: "18px 0 10px 0" }}>
                  {/* <AiFillSetting style={{ color: "#00000080" }} /> */}
                  <p className="admin-settings">Admin Settings</p>
                </div>
                <div className="customButton " onClick={() => handleProfile()}>
                  <AiOutlineUser style={{ color: "#0C2D06", fontSize: "1.3rem" }} />
                  <span className="profile-section-text">My Profile</span>
                </div>
                <div
                  className="customButton "
                  onClick={() => changedPassword()}
                >
                  <PiPassword style={{ color: "#0C2D06", fontSize: "1.3rem" }} />
                  <span className="profile-section-text">Change Password</span>
                </div>
                <hr style={{ margin: "0.5rem 0" }} />
                <div
                  className="customButton "
                  onClick={() => {
                    showDisplaymenu()
                    setOpenModal(true);
                  }}
                >
                  <FiLogOut
                    style={{
                      color: "#0C2D06",
                      fontSize: "1.3rem",
                    }}
                  />
                  <span className="profile-section-text">Logout</span>
                </div>
              </div>
            </div>
          ) : (
            false
          )}
        </div>
        <NavItem></NavItem>
      </NavMenu>
    </>
  );

  const [tableData, setTableData] = useState([]);
  // For Pagination
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalDocs, setTotalDocs] = useState(0);

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(1); // Reset to the first page when rows per page change
  };

  const handleChangePage = (event, newPage) => {
    // handleCancel();
    setPage(newPage);


    // localStorage.setItem("currentPage", newPage); // Store the page number

  };


  useEffect(() => {

    getCertificateNotification(page);

  }, [page, rowsPerPage]);


  const getCertificateNotification = async (currentPage) => {
    setIsLoading(true);
    // setTotalDocs(0);

    try {
      const { data } = await axios.get(`/private/getCertificateNotification?page=${currentPage}&limit=${rowsPerPage}`);

      console.log("dataCertificate",data)

      setTableData(data?.data?.docs);
      // setTotalDocs(data?.data?.totalDocs)

    } catch (error) {
      if (error?.response?.status === 419) {
        localStorage.clear();
        Cookies.remove("showProfileSidebar");
        setUsers("");
        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });
        navigate("/");
      } else {
        console.log("error", error?.response)
      }
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <>
      <IconContext.Provider value={{ color: "#000000" }}>
        <Nav>
          <NavbarContainer>
            <div
              style={{ display: "flex", alignItems: "center", gap: "4rem" }}
              onClick={() => {
                Cookies.set("showProfileSidebar", false, { expires: 365 });
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "0.3rem" }}>

                <NavLogo to={firstAllowedRoute} >
                  {/* <NavLogo to={firstAllowedRoute}  onClick={() => navigate(firstAllowedRoute)}></NavLogo> */}
                  <SvgLogo className="logoImage" src={navbarLogo} />
                </NavLogo>

                <span className="navbar-header">JobDash</span>
              </div>
            </div>

            <MobileIcon
              onClick={() => {
                showBackOverlay();
                showSidebar();
              }}
            >
              <FaBars style={{ color: "#000000" }} />
            </MobileIcon>
            <div style={{ display: "flex", gap: "2rem" }}>
              <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}>
                <div style={{ border: "1px solid #F2F4F8", padding: "0.3rem" }}
                  onClick={(e) => {
                    // setUserDetails(user);
                    handleFilterClick(e)
                  }}><FaRegBell style={{ fontSize: "1.3rem", }} /></div></div>
              {leftBox}
            </div>
          </NavbarContainer>
        </Nav>
      </IconContext.Provider>

      {/* Modal for logout  */}
      <Modal
        maxWidth="lg"
        width="350px"
        RoundedCorners={true}
        isOpen={openModal}
        onClose={() => {
          setOpenModal(false);
        }}
        backgroundModal={false}
        backgroundModalContent={false}
        title={
          <div>
            <div className="d-flex align-items-center justify-content-end">
              <RxCross2
                style={{
                  cursor: "pointer",
                }}
                onClick={() => { setOpenModal(false); }}
              />
            </div>
          </div>
        }
        content={
          <div >
            <div className="logout-content-container">
              <h6 style={{ textAlign: "left", color: "#181818", fontFamily: "Roboto", fontSize: "20px", fontWeight: "700" }}>Logout</h6>
              <h3 style={{ color: "#484848", fontFamily: "Roboto", fontSize: "16px", fontWeight: "400" }}>Are you sure you want to logout from this account</h3>
            </div>
            <div className="logout-button-group">
              <div
                className="cancel-button"
                onClick={() => {
                  setOpenModal(false);
                }}
              >
                Cancel
              </div>
              <div className="logout-button" onClick={() => handleLogout()}>
                Yes
              </div>
            </div>
          </div>
        }
      />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Box sx={{ width: "300px", maxHeight: "420px", overflow: "scroll" }}>
          <div>
            <div style={{ fontSize: "1rem", color: "#000000", fontWeight: "500", padding: "14px" }}>Notification</div>
            <hr style={{ margin: "0px" }} />

            {tableData && tableData.length > 0 ? (
              tableData.map((user, index) => (
                <div
                  key={index}
                  className="mainDataNavNotification"

                  onClick={() => {
                    if (user?.proposalType === "ticketNotification") {
                      navigate(`/ticketManagement`);
                      setAnchorEl(null);
                    } else {
                      navigate(`/userDetails/${user.certificateUserId}`);
                      setAnchorEl(null);
                    }
                  }}
                >
                  <div
                    style={{
                      height: "2.5rem",
                      width: "2.5rem",
                      borderRadius: "50%",
                    }}
                  >
                    <img
                      src={user?.userDetails?.profileImage || Placeholder}
                      alt="User"
                      style={{ height: "2.5rem", width: "2.5rem", borderRadius: "50%" }}
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", }}>
                    <div style={{ fontWeight: "500", color: "#09021C", fontSize: "14px" }}>{user?.title || "--"} </div>
                    <div style={{ fontWeight: "400", color: "#737373", fontSize: "12px" }}>{user?.description || "--"}</div>
                    <div style={{ fontWeight: "400", color: "#737373", fontSize: "12px" }}>{extractDate(user?.createdAt || "--")}</div>
                  </div>

                </div>
              ))
            ) : (
              <div>No data available</div>
            )}


          </div>
        </Box>
      </Popover >


      {isLoading && <Overlay />}
      {!sidebar ? <SidebarOverlay /> : ""}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
